var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',[_c('template',{slot:"brand"},[_c('b-navbar-item',[_c('img',{attrs:{"src":require("../assets/img/brand.png"),"alt":"Matcher"}}),_c('p',{staticClass:"branding"},[_vm._v(_vm._s(_vm.title))])])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }